"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("../constants/constants");
var _utils = require("../utils/utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * BwA Event Logger — thin logging layer called from GA event handlers after payload
 * is built. Adds logTime, batches, and sends via sendBeacon to Katal.
 */

var KATAL_ENDPOINT = _constants.API_ENDPOINTS.katalLogger;
var BATCH_TIMEOUT_MS = 3000;
var MAX_LOGS_PER_BATCH = 25;
var logQueue = [];
var batchTimer = null;
function flush() {
  if (batchTimer) {
    clearTimeout(batchTimer);
    batchTimer = null;
  }
  if (logQueue.length === 0) {
    return;
  }
  var batch = logQueue.splice(0);
  var payload = JSON.stringify({
    logs: batch
  });
  if (navigator.sendBeacon) {
    navigator.sendBeacon(KATAL_ENDPOINT, payload);
  } else {
    var xhr = new XMLHttpRequest();
    xhr.open("POST", KATAL_ENDPOINT, true);
    xhr.send(payload);
  }
}
window.addEventListener("visibilitychange", function () {
  if (document.visibilityState === "hidden") {
    flush();
  }
});
function safeSessionId() {
  try {
    return (0, _utils.getBwaMutantSessionId)() || null;
  } catch (e) {
    return null;
  }
}
function safeStoreDomain() {
  try {
    return window.location.hostname;
  } catch (e) {
    return null;
  }
}
function enqueue(eventName, fields) {
  logQueue.push({
    level: "info",
    message: "BWA_EVENT: " + eventName,
    context: _objectSpread(_objectSpread({
      // Auto-added join keys so every Katal event is stitchable (callers may override).
      bwaSessionId: safeSessionId(),
      storeDomain: safeStoreDomain(),
      pageReferrer: document.referrer || null
    }, fields), {}, {
      eventName: eventName,
      logTime: Date.now()
    })
  });
  if (logQueue.length >= MAX_LOGS_PER_BATCH) {
    flush();
  } else if (!batchTimer) {
    batchTimer = setTimeout(flush, BATCH_TIMEOUT_MS);
  }
}
function logEvent(eventName) {
  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  enqueue(eventName, fields);
}
var BwaEventLogger = {
  logEvent: logEvent
};
var _default = exports["default"] = BwaEventLogger;
//# sourceMappingURL=bwa-event-logger.js.map
